import React, { useState, useEffect, useMemo } from "react";
import { Table, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import ExportToExcel from "../../../../../components/ExportToExcel";
import Pagination from "../../../../../components/Pagination";
import SearchBar from "../../../../../components/SearchBar";
import moment from "moment";
import PayrollFilter from "./PayrollFilter";
import Select from "react-select";
import { FaSpinner } from "react-icons/fa";
import RujulColumnFilter from "../../../../../components/RujulColumnFilter";

const ConfirmationPayrollComponent = ({
  data,
  dataSets,
  columnHeadersMap,
  isSubmitStatus,
  handleReset,
  selectedResource,
  selectAllChecked,
  checkBoxRequiredMap,
  searchTerm,
  isRequiredStatus,
  isApiStatus,
  setSearchTerm,
  isFilterRequired,
  formDatas,
  handleGetData,
  handleChange,
  filterFormData,
  handleCheckboxChange,
  formattedKeys,
  totals,
  handleSubmitButton,
  handleApprovedByChange,
  handleSelectAllChange,
  ApprovedBYOptions,
  userName,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [rujulDataSet, setRujulDataset] = useState([])

  useEffect(() => {
    setRujulDataset(dataSets[activeTab])
  }, [dataSets])
  const [activeTab, setActiveTab] = useState(Object.keys(dataSets)[0]);
  const datasetKeys = Object.keys(dataSets);

  const datasetKeysColumnFilter = Object.keys(dataSets[activeTab]);

  const colummmm = (columnHeadersMap[activeTab] || []).map((el) => ({
    label: el?.label,
    value: el?.key
  }));

  console.log("colummmm", colummmm);
  const [visibleColumns, setVisibleColumns] = useState({});
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });

  const [filteredData, setFilteredData] = useState(null);
  console.log("filteredData", filteredData);


  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  // Debounce search term
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 300);
    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);
  // Search functionality for both main data and dataSets
  const displayedData = useMemo(() => {
    // Use filteredData if it exists, otherwise use the original dataset
    const datasetToFilter = filteredData || dataSets[activeTab] || [];

    if (!debouncedSearchTerm) return datasetToFilter;

    return datasetToFilter.filter((item) =>
      Object.values(item).some((value) =>
        String(value).toLowerCase().includes(debouncedSearchTerm.toLowerCase())
      )
    );
  }, [dataSets, activeTab, debouncedSearchTerm, filteredData]);

  const filteredDataSets = useMemo(() => {
    const result = {};
    Object.keys(dataSets).forEach((key) => {
      const dataset = dataSets[key];
      if (Array.isArray(dataset)) {
        result[key] = dataset.filter((item) =>
          Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchTerm.toLowerCase())
          )
        );
      }
    });
    return result;
  }, [dataSets, searchTerm]);

  // Sorting functionality
  const sortedData = useMemo(() => {
    if (!Array.isArray(displayedData) || !sortConfig) return displayedData || [];

    const { key, direction } = sortConfig;

    return [...displayedData].sort((a, b) => {
      const valA = a[key] ? String(a[key]) : "";
      const valB = b[key] ? String(b[key]) : "";

      const partsA = valA.match(/(\D+|\d+)/g) || [];
      const partsB = valB.match(/(\D+|\d+)/g) || [];

      for (let i = 0; i < Math.max(partsA.length, partsB.length); i++) {
        const partA = partsA[i] || "";
        const partB = partsB[i] || "";

        const isNumericA = !isNaN(partA);
        const isNumericB = !isNaN(partB);

        if (isNumericA && isNumericB) {
          const numA = Number(partA);
          const numB = Number(partB);
          if (numA !== numB)
            return direction === "ascending" ? numA - numB : numB - numA;
        } else if (isNumericA || isNumericB) {
          return isNumericA ? -1 : 1;
        } else {
          const comparison = partA.localeCompare(partB);
          if (comparison !== 0)
            return direction === "ascending" ? comparison : -comparison;
        }
      }

      return 0;
    });
  }, [displayedData, sortConfig]);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, sortedData.length);
  const currentData = sortedData.slice(startIndex, endIndex);

  const recordsPerPageOption = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: sortedData.length, label: "All" },
  ];

  const [selectedRecordsPerPage, setSelectedRecordsPerPage] = useState(10);

  const totalPages = Math.ceil(sortedData.length / selectedRecordsPerPage);

  const currentPageData = sortedData.slice(
    (currentPage - 1) * selectedRecordsPerPage,
    currentPage * selectedRecordsPerPage
  );

  const handleRecordsPerPage = (e) => {
    const newRecordsPerPage = Number(e.target.value);
    const currentStartIndex = (currentPage - 1) * selectedRecordsPerPage;
    const newPage = Math.floor(currentStartIndex / newRecordsPerPage) + 1;
    setSelectedRecordsPerPage(newRecordsPerPage);
    setCurrentPage(newPage);
    setItemsPerPage(newRecordsPerPage);
  };

  useEffect(() => {
    const dropdownElements = document.querySelectorAll(".dropdown-toggle");
    dropdownElements.forEach((dropdown) => {
      new window.bootstrap.Dropdown(dropdown);
    });
  }, []);

  return (
    <div className="container-fluid ">
      <div className="row d-flex justify-content-between align-items-center">
        {/* Left Section: Search Bar & Filters */}
        <div className="col-md-6 d-flex align-items-center">
          <div className="me-2 mt-3">
            <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
          </div>
          {isFilterRequired && (
            <div className="dropdown">
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip id="tooltip-bottom">Filters</Tooltip>}
              >
                <button
                  className="dropdown-toggle"
                  type="button"
                  id="excel-btn"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bi bi-funnel-fill"></i>
                </button>
              </OverlayTrigger>
              <div>
                <PayrollFilter
                  formData={formDatas || []}
                  handleChange={handleChange}
                  handleReset={handleReset}
                  handleGetData={handleGetData}
                  filterFormData={filterFormData}
                />
              </div>
            </div>
          )}

        </div>

        <div className="col-md-6 d-flex justify-content-end align-items-center">
          <div className="col-md-6 d-flex justify-content-end align-items-center">
            <div className="me-3 mt-3">
              <div className="dropdown">
                <OverlayTrigger
                  placement="right"
                  overlay={<Tooltip id="tooltip-bottom">Filters</Tooltip>}
                >
                  <button
                    className="dropdown-toggle"
                    type="button"
                    id="excel-btn"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="bi bi-funnel-fill"></i>
                  </button>
                </OverlayTrigger>
                <div>
                  <RujulColumnFilter
                    columnOptions={colummmm}
                    columnHeadersMap={columnHeadersMap}
                    dataSets={rujulDataSet}
                    onFilterApplied={(filteredData) => {
                      setFilteredData(filteredData); // Store filtered data in state
                    }}
                    datasetKey="Calculate Payroll"
                  />
                </div>
              </div>
            </div>


          </div>
          <div
            className="me-3 "
            style={{
              minWidth: "250px",
              width: "40%",
            }}
          >
            <label className="form-label d-block">Approved By</label>
            <Select
              options={ApprovedBYOptions}
              onChange={(selectedOptions) =>
                handleApprovedByChange(selectedOptions)
              }
              value={ApprovedBYOptions?.find((o) => o.value === userName)}
              isDisabled={true}
            />
          </div>
          <div className="d-flex align-items-center mt-3">
            <button
              className="custom-btn"
              onClick={handleSubmitButton}
              disabled={isSubmitStatus} // 🔒 disable when loading
            >
              {isSubmitStatus ? <FaSpinner className="sm-spinner" /> : "Submit"}
            </button>
          </div>
        </div>
      </div>
      <div className="m-0">
        <div className="m-0 p-0">
          <ul className="nav nav-tabs">
            {datasetKeys?.map((key, index) => (
              <li className="nav-item" key={index}>
                <button
                  className={`nav-link ${activeTab === key ? "active" : ""}`}
                  onClick={() => setActiveTab(key)}
                >
                  {key}
                </button>
              </li>
            ))}
          </ul>

          {/* Dynamic Tabs Content */}
          <div className="tab-content mt-3">
            {datasetKeys.map((key, index) => {
              // const currentDataSet = filteredDataSets[key] || dataSets[key];
              const columnHeaders = columnHeadersMap[key] || [];
              return (
                <div
                  key={index}
                  className={`table-responsive tab-pane fade ${activeTab === key ? "show active" : ""
                    }`}
                      style={{
    maxHeight: '500px',
    overflow: 'auto',
    position: 'relative'
  }}
                >
                  <Table striped bordered hover rounded>
                    <thead id="thcolor" className="text-center">
                      <tr>
                        {checkBoxRequiredMap[key] && (
                          <th style={{ width: "25px" }}>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={selectAllChecked}
                              onChange={(e) => handleSelectAllChange(e)}
                            />
                          </th>
                        )}
                        {columnHeaders.map(
                          (col, i) =>
                            visibleColumns[col.key] !== false && (
                              <th key={i}>{col.label}</th>
                            )
                        )}
                      </tr>
                    </thead>
                    {isRequiredStatus &&
                      (isApiStatus === 200 && sortedData?.length !== 0 ? (
                        <tbody>
                          {Array.isArray(sortedData)
                            ? sortedData.map((row, i) => (
                              <tr key={i}>
                                {checkBoxRequiredMap[key] && (
                                  <td>
                                    <input
                                      className="form-check-input text-end"
                                      type="checkbox"
                                      checked={
                                        !!selectedResource?.find(
                                          (o) => o.ContactID === row.ContactID
                                        )
                                      }
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          e,
                                          row.ContactID,
                                          row
                                        )
                                      }
                                    />
                                  </td>
                                )}
                                {columnHeaders.map(
                                  (col, j) =>
                                    visibleColumns[col.key] !== false && (
                                      <td
                                        className={
                                          col.key != "Employee"
                                            ? `text-end`
                                            : "text-start"
                                        }
                                        key={j}
                                      >
                                        {row[col.key]}
                                      </td>
                                    )
                                )}
                              </tr>
                            ))
                            : ""}

                          {sortedData?.length !== 0 &&
                            key === "Confirmation Payroll" && (
                              <tr
                                style={{
                                  fontWeight: "bold",
                                  backgroundColor: "#f0f0f0",
                                }}
                              >
                                {checkBoxRequiredMap[key] && <td></td>}
                                <td>Count: {sortedData.length}</td>

                                {formattedKeys.map(({ key }) => (
                                  <td className="text-end" key={key}>
                                    {totals?.[key]?.toFixed(2) ?? '-'}
                                  </td>
                                ))}
                              </tr>
                            )}
                        </tbody>
                      ) : isApiStatus === 200 &&
                        sortedData?.length === 0 ? (
                        <tbody>
                          <tr>
                            <td
                              colSpan={
                                columnHeaders.length +
                                (checkBoxRequiredMap[key] ? 1 : 0)
                              }
                              className="text-center"
                            >
                              <p>No Data Found</p>
                            </td>
                          </tr>
                        </tbody>
                      ) : isApiStatus === undefined &&
                        sortedData?.length === 0 ? (
                        <tbody>
                          <tr>
                            <td
                              colSpan={
                                columnHeaders.length +
                                (checkBoxRequiredMap[key] ? 1 : 0)
                              }
                              className="text-center"
                            >
                              <div>
                                <p>
                                  <FaSpinner className="spinner" />
                                  <br />
                                  Loading
                                </p>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      ) : isApiStatus !== 200 &&
                        sortedData?.length === 0 ? (
                        <tbody>
                          <tr>
                            <td
                              colSpan={
                                columnHeaders.length +
                                (checkBoxRequiredMap[key] ? 1 : 0)
                              }
                              className="text-center"
                            >
                              <p>No Data Found</p>
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        <tbody>
                          <tr>
                            <td
                              colSpan={
                                columnHeaders.length +
                                (checkBoxRequiredMap[key] ? 1 : 0)
                              }
                              className="text-center"
                            >
                              <div>
                                <p>
                                  <FaSpinner className="spinner" />
                                  <br />
                                  Loading
                                </p>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      ))}
                  </Table>
                </div>
              );
            })}
          </div>
        </div>

        <div className="d-flex justify-content-between mb-3">
          <div>
            <span className="d-flex">
              Showing {(currentPage - 1) * selectedRecordsPerPage + 1} -{" "}
              {Math.min(
                currentPage * selectedRecordsPerPage,
                sortedData.length
              )}{" "}
              of {sortedData.length} <span className="ms-1">results</span>
              <select
                value={selectedRecordsPerPage}
                onChange={handleRecordsPerPage}
                className="mx-2 form-select-sm"
              >
                {recordsPerPageOption.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </span>
          </div>
          <div>
            <Pagination
              itemsPerPage={selectedRecordsPerPage}
              totalItems={sortedData.length}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPayrollComponent;